// import {
//   NOTEBOOK_SECTIONS,
//   PROTOCOL_SLIDE_TYPES,
// } from '@learningblocks/protocol-constants/lib/Utilities';
const DATA_FILE = require('./data.json');

export const FILES = {
  levelOne: createJSONTree(require('./levelOne.json')),
  levelTwo: createJSONTree(require('./levelTwo.json')),
  levelThree: createJSONTree(require('./levelThree.json')),
};

// function createJSONTree(jsonFile) {
//   const sourceTree = JSON.parse(JSON.stringify(jsonFile));
//   const targetTree = {};
//   targetTree.COMPONENTS = MainComponents(sourceTree.COMPONENTS);
//   for (let component of targetTree.COMPONENTS) {
//     switch (component) {
//       case NOTEBOOK_SECTIONS.CONTEXT:
//       case NOTEBOOK_SECTIONS.MATERIALS:
//       case NOTEBOOK_SECTIONS.PREDICTIONS:
//       case NOTEBOOK_SECTIONS.PROTOCOL:
//       case NOTEBOOK_SECTIONS.RESULTS:
//       case NOTEBOOK_SECTIONS.REFLECTION:
//       case NOTEBOOK_SECTIONS.SUMMARY:
//         targetTree[component] = makeCommonSections(sourceTree, component);
//         break;
//       // case NOTEBOOK_SECTIONS.PROTOCOL:
//       //   targetTree[component] = makeDesignSection(sourceTree);
//       //   break;
//       default:
//         continue;
//     }
//   }
//   return targetTree;
// }
//
// function makeSectionKey(title) {
//   return title.split(' ').join('_');
// }
//
// function MainComponents(components) {
//   return components.map((comp) => makeSectionKey(comp.title));
// }
//
// function makeCommonSections(jsonFile, component) {
//   const section = fetchSection(jsonFile, component);
//   section.components = section.components.map(fetchDataByID);
//   return section;
// }
//
// function fetchSection(jsonFile, section) {
//   return jsonFile.COMPONENTS.find(
//     (comp) => makeSectionKey(comp.title) === section
//   );
// }
//
// function fetchDataByID(ID) {
//   return DATA_FILE.components.find((data) => data.id === ID);
// }
//
// function makeDesignSection(jsonFile) {
//   const section = fetchSection(jsonFile, NOTEBOOK_SECTIONS.PROTOCOL);
//   section.allSlides = section.allSlides.map(fetchDataBySlide);
//   return section;
// }
//
// function fetchDataBySlide(slide) {
//   if (slide.type === PROTOCOL_SLIDE_TYPES.ONE) {
//     slide.options = slide.options.map(fetchDataByID);
//     slide.inputNodes = slide.inputNodes.map(fetchDataByID);
//     slide.outputNodes = slide.outputNodes.map(fetchDataByID);
//   } else {
//     slide.slideTree = slide.slideTree.map((group) => {
//       group.groupNodes = group.groupNodes.map((node) => {
//         node.nodeComponents = node.nodeComponents.map(fetchDataByID);
//         node.nodeOptions = node.nodeOptions.map(fetchDataByID);
//         return {...node};
//       });
//       return {...group};
//     });
//   }
//   return {...slide};
// }


function createJSONTree(jsonFile) {
  const source = JSON.parse(JSON.stringify(jsonFile));
  const target = {
    GENERAL_CONFIG: getGeneralConfig(source),
    MENU_LIST: getNotebookMenuList(source.COMPONENTS),
    GENERIC_CHAPTERS: getGenericChapters(source.COMPONENTS),
    PROTOCOL_CHAPTER: getProtocolChapter(source.COMPONENTS),
  };
  return target;
}

function getProtocolChapter(sourceComponents) {
  const protocolChapter = sourceComponents.find(
    (component) => component.value === "PROTOCOL"
  );

  console.log({"Protocol chapter": protocolChapter})
  return protocolChapter;
}


function getGeneralConfig(source) {
  return source.GENERAL_CONFIG;
}

function getNotebookMenuList(sourceComponents) {
  return sourceComponents.map((menu, index) => ({
    number: index + 1,
    title: menu.title,
    value: menu.value,
    current: menu.current,
    visited: menu.visited,
  }));
}

function fetchComponentByID(ID) {
  return DATA_FILE.components.find((data) => data.id === ID);
}

function getGenericChapters(sourceComponents) {
  return sourceComponents.reduce((genericChapters, chapter) => {
    if (chapter.isGenericChapter) {
      genericChapters[chapter.value] = {
        title: chapter.title,
        components: chapter.components.map(fetchComponentByID),
      };
    }
    return genericChapters;
  }, {});
}
